import { Flex, Skeleton } from '@percent/lemonade'
import classes from './BadgeCard.module.scss'

export function BadgeCardSkeleton() {
  return (
    <Flex direction="column" gap={8} className={classes.CardWrapper}>
      <Skeleton variant="circular" width={64} height={64} />
      <Flex direction="column" gap={4}>
        <Skeleton width={120} height={20} />
        <Skeleton width={100} height={16} />
      </Flex>
    </Flex>
  )
}
